// extracted by mini-css-extract-plugin
export default {"auctionSectionContainer":"_66180c59","auctionItems":"_e64b0fb1","buttonWrapper":"_b6b176f9","header":"_cacb0783"};